export enum DocumentCategory {
  TechnicalLibrary,
  PartnerResource,
}

export enum TechLibraryDocumentType {
  // Technical Library
  TechBulletin = 'TechBulletin',
  ReleaseNote = 'ReleaseNote',
  TechSpecification = 'TechSpecification',
  SystemDiagram = 'SystemDiagram',
  ProductLifecycle = 'ProductLifecycle',

  // Partner Resources
  PartnerMarketingAssets = 'PartnerMarketingAssets',
  PartnerPromotional = 'PartnerPromotional',
  PartnerTraining = 'PartnerTraining',
  PartnerTools = 'PartnerTools',
  PartnerOther = 'PartnerOther',
}

export enum DocumentFamily {
  Firmware = 'CasFirmware',
  CasGen2 = 'CasGen2',
  CasGen3 = 'CasGen3',
  DataPlatform = 'DataPlatform',
  DGS = 'DGS',
  CasHardware = 'CasHardware',
  Other = 'Other',
}

export enum DocumentProduct {
  Camera = 'Camera',
  CASWeb = 'CASWeb',
  DashAlarm = 'DashAlarm',
  Datalogger = 'Datalogger',
  DGSMobile = 'DGSMobile',
  DGSUphole = 'DGSUphole',
  DigitalMinePortal = 'DigitalMinePortal',
  DisplayUnit = 'DisplayUnit',
  ExpansionUnit = 'ExpansionUnit',
  GroundSpeedUnit = 'GroundSpeedUnit',
  ICU = 'ICU',
  IVUSTM = 'IVUSTM',
  IVUPlus = 'IVUPlus',
  IVUOne = 'IVUOne',
  LFM = 'LFM',
  Node = 'Node',
  PCU = 'PCU',
  PPULFM = 'PPULFM',
  PPUUWB = 'PPUUWB',
  PRU = 'PRU',
  PWMDecoder = 'PWMDecoder',
  RTK = 'RTK',
  TOF = 'TOF',
  USBDSRC = 'USBDSRC',
  X1 = 'X1',
  X9 = 'X9',
  V2X = 'V2X',
  DGSDownhole = 'DGSDownhole',
  System = 'System',
  Installation = 'Installation',
  Antenna = 'Antenna',
  Other = 'Other',
}

export enum PartnerResourceFileType {
  Video = 'Video',
  PDF = 'PDF',
  Image = 'Image',
  Excel = 'Excel',
  Link = 'Link',
}

export interface FileLinkModel {
  downloadUri: string;
  fileSize: number;
}

export interface DocumentModel extends FileLinkModel {
  id: number;
  documentType: TechLibraryDocumentType;
  title: string;
  description: string;
}

export interface TechLibraryDocumentModel extends DocumentModel {
  filename: string;
  releaseDate: string;
  releaseVersion?: string;
  products: DocumentProduct[];
  productFamilies: DocumentFamily[];
}

export interface PartnerResourceModel extends DocumentModel {
  fileType: PartnerResourceFileType;
  date: string;
}
